import RiskProfileItem, { RISK_SCORE_TYPE, SelectedRiskProfile } from '@/types/risk-profile-item';

export const addUpRiskToProfile = (newRiskProfile: SelectedRiskProfile, recommendedRiskProfile: RiskProfileItem, scoreType: RISK_SCORE_TYPE) => {
  switch (scoreType) {
    case RISK_SCORE_TYPE.ORDER:
      newRiskProfile.upRisk = {
        riskScore: newRiskProfile.order,
        recommendedRiskScore: recommendedRiskProfile.order,
        scoreType: RISK_SCORE_TYPE.ORDER,
        recommendedRiskProfileId: recommendedRiskProfile._id,
      };
      break;
  }
};
